<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
        <v-combobox
                v-model="selectedMailingGroupsTemp"
                :items="mailingGroups"
                chips
                :label="label"
                :disabled="!edit"
                multiple
                clearable
                persistent-hint
                item-text="title"
                item-value="id"
                hide-selected
                hide-details
                @input="changeGroups"
        >
            <template v-slot:selection="{ index, item }">
                <v-chip
                        :key="index"
                        close
                        @click:close="removeGroup(index)"
                >
                    {{ item.title }}
                </v-chip>
            </template>
        </v-combobox>
</template>

<script>
export default {
    name: 'MailingGroupsPicker',
    props: ['newLabel', 'newFieldName', 'mailingGroups', 'selectedMailingGroups', 'edit'],
    data () {
        return {
            label: 'Группы для рассыки',
            fieldName: 'group_ids',
            selectedMailingGroupsTemp: []
        }
    },
    created() {
        if (this.newLabel !== undefined) {
            this.label = this.newLabel
        }
        if (this.newFieldName !== undefined) {
            this.fieldName = this.newFieldName
        }
        this.selectedMailingGroupsTemp = this.selectedMailingGroups
    },
    methods: {
        changeGroups() {
            let groupIds = []
            for (let i = 0; i < this.selectedMailingGroupsTemp.length; i++) {
                groupIds.push(this.selectedMailingGroupsTemp[i].id)
            }
            groupIds = groupIds.join(',')
            this.$emit('updateGroups', { field: this.fieldName, group_ids: groupIds, selectedMailingGroups: this.selectedMailingGroupsTemp })
        },
        removeGroup(index) {
            this.selectedMailingGroupsTemp.splice(index, 1)
            this.changeGroups()
        }
    },
    watch: {
        selectedMailingGroups(value) {
            this.selectedMailingGroupsTemp = value
        }
    }
}
</script>

<style scoped>

</style>
